module.exports = __webpack_public_path__ + "img/welfare-ico-1.99c68d95.png";